import { render, staticRenderFns } from "./ListExplanation.vue?vue&type=template&id=33963470"
import script from "./ListExplanation.vue?vue&type=script&lang=js"
export * from "./ListExplanation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./ListExplanation.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('33963470')) {
      api.createRecord('33963470', component.options)
    } else {
      api.reload('33963470', component.options)
    }
    module.hot.accept("./ListExplanation.vue?vue&type=template&id=33963470", function () {
      api.rerender('33963470', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/tasks/views/ListExplanation.vue"
export default component.exports